import { Link } from '~/components'
import ResponsiveImage from '~/components/Image/ResponsiveImage'

import { MenuSubCategoryType } from '../types/category.types'

export default function MenuItem({ item }: { item: MenuSubCategoryType }): React.ReactElement {
  const {
    key,
    title,
    subtitle,
    image = '',
    imageAlt = '',
    imageClassName,
    imageHeight = 46,
    imageWidth = 46,
    hasWideLogo = false,
    url = '',
    isBetaFeature = false,
    onClickHandler = () => {},
  } = item

  const isLocalImage = image.startsWith('/')
  const iconClassName = imageClassName ?? (hasWideLogo ? 'max-h-9 w-auto' : 'w-7')

  return (
    <Link
      className="flex w-full cursor-pointer items-center gap-3.5 rounded-2 px-2.5 py-2 duration-300 hover:bg-purple-darker"
      data-test-id={`menu-item-${key}`}
      onClick={onClickHandler}
      to={url}
    >
      <span className={`flex shrink-0 items-center justify-center ${hasWideLogo ? 'h-9 w-11.5' : 'w-7'}`}>
        {isLocalImage ? (
          <ResponsiveImage
            alt={imageAlt}
            height={imageHeight}
            imageClassName={iconClassName}
            src={image}
            width={imageWidth}
          />
        ) : (
          <ResponsiveImage
            alt={imageAlt}
            fit="contain"
            height={imageHeight}
            imageClassName={iconClassName}
            srcKey={image}
            width={imageWidth}
          />
        )}
      </span>
      <span className="flex flex-col items-start">
        <span className="flex items-center gap-2">
          <p className="text-xs font-medium leading-3 text-white">{title}</p>
          {isBetaFeature && (
            <span className="rounded-full bg-pink px-2 py-0.5 text-xs font-semibold text-white shadow">Beta</span>
          )}
        </span>
        {subtitle && <p className="hidden text-xs leading-5.5 text-white md:block">{subtitle}</p>}
      </span>
    </Link>
  )
}
